
<mapfre-generic-information-template
[headerImageURL]="'./assets/img/images/headers/discounts.png'"
[backButtonUrl]="'/information'"
[type]="'page'">
<h1 class="information-title">{{ 'INFORMATION_DISCOUNTS_1' | translate }}</h1>
      <div class="row information-content">
        <div class="col">
          <p class="information-par-margin">
              {{ 'INFORMATION_DISCOUNTS_2' | translate }}
          </p>
         
          <ul class="information-par-margin">
              <li>{{ 'INFORMATION_DISCOUNTS_3' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_4' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_5' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_6' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_7' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_8' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_9' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_10' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_11' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_12' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_13' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_14' | translate }}</li>
              <li>{{ 'INFORMATION_DISCOUNTS_15' | translate }}</li>
          </ul>
        </div>
      </div>
</mapfre-generic-information-template>